import { useCallback, useEffect, useState } from 'react';
import {
  fetchKrHoldingsOwnership,
  fetchMarketWatchlists,
  importKrxSeedWatchlist,
  importTossKrHoldings,
  KrHoldingOwnership,
  MarketWatchlist,
  refreshGeminiKrWatchlist,
  refreshUsLiveCandidates,
  refreshTossKrWatchlist,
  refreshTossUsWatchlist,
} from '../services/marketWatchlistApi';

export function useMarketWatchlists() {
  const [items, setItems] = useState<MarketWatchlist[]>([]);
  const [krHoldings, setKrHoldings] = useState<KrHoldingOwnership[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const [watchlists, ownership] = await Promise.all([
        fetchMarketWatchlists(),
        fetchKrHoldingsOwnership(),
      ]);
      setItems(watchlists);
      setKrHoldings(ownership.items || []);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'watchlist 조회 실패');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  async function importHoldings() {
    setLoading(true);
    setError(null);
    try {
      await importTossKrHoldings();
      await load();
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Toss 보유종목 import 실패');
    } finally {
      setLoading(false);
    }
  }

  async function importKrxSeed() {
    setLoading(true);
    setError(null);
    try {
      await importKrxSeedWatchlist();
      await load();
    } catch (err) {
      setError(err instanceof Error ? err.message : 'KRX seed import 실패');
    } finally {
      setLoading(false);
    }
  }

  async function refreshKrGemini() {
    setLoading(true);
    setError(null);
    try {
      await refreshGeminiKrWatchlist();
      await load();
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Gemini KR 후보 생성 실패');
    } finally {
      setLoading(false);
    }
  }

  async function refreshUsToss() {
    setLoading(true);
    setError(null);
    try {
      await refreshTossUsWatchlist();
      await load();
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Toss US 후보 검증 실패');
    } finally {
      setLoading(false);
    }
  }

  async function refreshUsLive() {
    setLoading(true);
    setError(null);
    try {
      await refreshUsLiveCandidates();
      await load();
    } catch (err) {
      setError(err instanceof Error ? err.message : 'US LIVE 후보 생성/검증 실패');
    } finally {
      setLoading(false);
    }
  }

  async function refreshKrToss() {
    setLoading(true);
    setError(null);
    try {
      await refreshTossKrWatchlist();
      await load();
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Toss KR 후보 검증 실패');
    } finally {
      setLoading(false);
    }
  }

  return {
    items, krHoldings, loading, error, reload: load, importHoldings,
    importKrxSeed, refreshKrGemini, refreshUsToss, refreshUsLive, refreshKrToss,
  };
}
